import {
  WhatMakesDifferentSection,
  OurPromiseSection,
  CustomerSolutionsSection,
  TestimonialsSection,
  StatsSection,
  TechInnovationSection,
  EnvironmentalSection,
} from "@features/residential/components";

interface WhyChooseGazPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function WhyChooseGazPage({ hero, footer }: WhyChooseGazPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <WhatMakesDifferentSection />
      <OurPromiseSection />
      <CustomerSolutionsSection />
      <TestimonialsSection />
      <StatsSection />
      <TechInnovationSection />
      <EnvironmentalSection />
      {footer}
    </div>
  );
}
